import { Component, HostListener, OnInit } from '@angular/core';
import { GoogleChartService } from  '../service/google-chart.service';  

@Component({
  selector: 'gp-line-chart',
  templateUrl: './line-chart.component.html',
  styleUrls: ['./line-chart.component.scss']
})
export class LineChartComponent implements OnInit {

  private gLib: any;

  constructor(private gChartService : GoogleChartService) {
    this.gLib = this.gChartService.getGoogle();
    this.gLib.charts.load('current', {'packages':['corechart','table']});
    this.gLib.charts.setOnLoadCallback(this.drawChart.bind(this));
   }

  ngOnInit(): void {
  }

  private drawChart(){
    let data = this.gLib.visualization.arrayToDataTable([
      ['Year', 'Low', 'Medium', 'High'],
      ['2021',  10000,      10000, 10000],
      ['2022',  10100,      11100, 12100],
      ['2023',  10200,      11200, 12200],
      ['2024',  10300,      11300, 12300],
      ['2025',  10400,      11400, 12400],
      ['2026',  10500,      11500, 12500]      
    ]);

    let options = {'title':'Asset Projection',
      width: '100%',
      height: '100%',      
      legend: { position: 'bottom' },
      // chartArea: {
          
      //       height: "80%",
      //       width: "100%"
      //   },
  };


   

    let chart = new this.gLib.visualization.LineChart(document.getElementById('divLineChart'));

    chart.draw(data, options);
  }

  @HostListener('window:resize', ['$event'])
  onResize(){
    this.drawChart();
  }

}
